(() => {
  'use strict';
  if (window.Sn84CartState) return;
  const controls = '#CartDrawer-Checkout, #checkout, cart-items .quantity__button, cart-drawer-items .quantity__button, cart-items .quantity__input, cart-drawer-items .quantity__input, cart-remove-button a, form[data-sn74-discount] button, .sv15-suggest__form button, .sv15-suggest__form select';
  const quantitySelector = 'cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"]';
  const roots = 'cart-drawer, cart-items, #main-cart-footer';
  const records = new Map();
  const busyRoots = new Map();
  const addNotices = new Map();
  let active = null;
  let observer = null;
  let scheduled = false;
  let checkoutTimer = null;
  let checkoutPending = false;
  let needsCartRefresh = false;
  const failureText = () => window.cartStrings?.error || '';
  const isAddForm = form => {
    if (!form?.matches?.('form')) return false;
    if (form.matches('product-form form, [data-sn48-form], [data-type="add-to-cart-form"]')) return true;
    const url = new URL(form.action, location.href);
    return url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
  };
  const clearAddNotices = () => {
    addNotices.forEach((notice, textNode) => {
      if (textNode.textContent !== notice.message) return;
      if (notice.created) notice.wrapper.remove();
      else {
        textNode.textContent = notice.text;
        notice.wrapper.hidden = notice.hidden;
      }
    });
    addNotices.clear();
  };
  const messageTargets = form => {
    const product = form?.closest('product-form');
    let wrapper = product?.querySelector('.product-form__error-message-wrapper') || form?.querySelector('[data-sn48-error], [data-sn84-add-wait]');
    let created = false;
    if (!wrapper && form) {
      wrapper = document.createElement('p');
      wrapper.setAttribute('data-sn84-add-wait', '');
      wrapper.setAttribute('role', 'status');
      form.append(wrapper);
      created = true;
    }
    const targets = wrapper ? [{ wrapper, textNode: wrapper.querySelector('.product-form__error-message') || wrapper, created }] : [];
    const sticky = form?.closest('[data-sn17-product]')?.querySelector('[data-sn17-sticky]');
    if (sticky) {
      let notice = sticky.querySelector('[data-sn84-sticky-feedback]');
      const isNew = !notice;
      if (!notice) {
        notice = document.createElement('span');
        notice.className = 'sn17-sticky-meta';
        notice.setAttribute('data-sn84-sticky-feedback', '');
        notice.setAttribute('role', 'status');
        (sticky.querySelector('div') || sticky).append(notice);
      }
      targets.push({ wrapper: notice, textNode: notice, created: isNew });
    }
    return targets;
  };
  const clearAddError = form => {
    form?.closest('product-form')?.querySelectorAll('[data-sn84-retry-link]').forEach(node => node.remove());
    form?.querySelectorAll('[data-sn84-retry-link]').forEach(node => node.remove());
    form?.closest('[data-sn17-product]')?.querySelectorAll('[data-sn84-sticky-feedback]').forEach(node => node.remove());
  };
  const guardAdd = (form, event) => {
    if ((!active && !checkoutPending && !needsCartRefresh) || !isAddForm(form)) return false;
    event?.preventDefault();
    event?.stopImmediatePropagation();
    if (!active && !checkoutPending && needsCartRefresh) {
      showAddError(form);
      return true;
    }
    const cartStatus = document.querySelector('[data-sn84-cart-status]');
    const message = cartStatus?.dataset[checkoutPending ? 'checkout' : 'loading'] || failureText();
    messageTargets(form).forEach(({ wrapper, textNode, created }) => {
      if (!addNotices.has(textNode)) addNotices.set(textNode, { wrapper, text: textNode.textContent, hidden: wrapper.hidden, created, message });
      else addNotices.get(textNode).message = message;
      textNode.textContent = message;
      wrapper.hidden = false;
    });
    return true;
  };
  const status = (kind, error = '') => document.querySelectorAll('[data-sn84-cart-status]').forEach(node => {
    const text = error || (kind ? node.dataset[kind === 'checkout' ? 'checkout' : 'loading'] || '' : '');
    if (node.textContent !== text) node.textContent = text;
    node.hidden = !text;
    if (error) node.dataset.state = 'error';
    else delete node.dataset.state;
  });
  const cartStrings = () => {
    try { return JSON.parse(document.querySelector('[data-sn67-cart-strings]')?.textContent || '{}'); } catch { return {}; }
  };
  const retryLink = (nodes = document.querySelectorAll('[data-sn84-cart-status]')) => {
    const strings = cartStrings();
    if (!strings.viewCart) return;
    const url = new URL(strings.cartUrl || window.routes?.cart_url || '/cart', location.href);
    if (url.origin !== location.origin) return;
    nodes.forEach(node => {
      if (node.querySelector('[data-sn84-retry-link]')) return;
      const link = document.createElement('a');
      link.setAttribute('data-sn84-retry-link', '');
      link.href = url.href;
      link.textContent = strings.viewCart;
      node.append(document.createTextNode(' '), link);
      node.hidden = false;
    });
  };
  const showAddError = (form, token) => {
    if (token?.controller.signal.aborted) return;
    const message = token?.uncertain ? cartStrings().addUncertain || failureText() : failureText();
    messageTargets(form).forEach(({ wrapper, textNode }) => {
      textNode.textContent = message;
      wrapper.hidden = false;
      retryLink([wrapper]);
    });
  };
  const restoreControls = () => {
    records.forEach((record, element) => {
      if ('disabled' in element) element.disabled = record.disabled;
      if (record.aria === null) element.removeAttribute('aria-disabled');
      else element.setAttribute('aria-disabled', record.aria);
      element.removeAttribute('data-sn84-locked');
    });
    records.clear();
    busyRoots.forEach((value, element) => {
      if (value === null) element.removeAttribute('aria-busy');
      else element.setAttribute('aria-busy', value);
    });
    busyRoots.clear();
  };
  const sync = () => {
    scheduled = false;
    if (!active && !checkoutPending) return;
    document.documentElement.setAttribute('data-sn84-cart-busy', active?.kind || 'checkout');
    document.querySelectorAll(roots).forEach(element => {
      if (!busyRoots.has(element)) busyRoots.set(element, element.getAttribute('aria-busy'));
      if (element.getAttribute('aria-busy') !== 'true') element.setAttribute('aria-busy', 'true');
    });
    document.querySelectorAll(controls).forEach(element => {
      if (!records.has(element)) records.set(element, { disabled: element.disabled, aria: element.getAttribute('aria-disabled') });
      if (active?.kind === 'suggestion' && !active.lockSource && active.owner.contains(element)) return;
      if ('disabled' in element && !element.disabled) element.disabled = true;
      if (element.getAttribute('aria-disabled') !== 'true') element.setAttribute('aria-disabled', 'true');
      if (!element.hasAttribute('data-sn84-locked')) element.setAttribute('data-sn84-locked', '');
    });
    status(active?.kind || 'checkout');
  };
  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(sync);
  };
  const begin = (owner, kind = 'quantity') => {
    if (checkoutPending) return null;
    if (active) {
      if (active.owner === owner && active.kind === kind && active.reserved) {
        active.reserved = false;
        clearTimeout(active.reserveTimer);
        return active;
      }
      return null;
    }
    if (kind === 'purchase' || kind === 'suggestion') clearAddError(owner.matches('form') ? owner : owner.querySelector('form'));
    active = { owner, kind, controller: new AbortController(), reserved: false, lockSource: false };
    const token = active;
    token.timer = setTimeout(() => { token.controller.abort(); if (token.posted) needsCartRefresh = true; token.feedback = { error: failureText(), retry: true }; end(token); }, 45000);
    if (!observer) observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
    return active;
  };
  const end = token => {
    if (!token || active !== token) return;
    clearTimeout(token.reserveTimer);
    clearTimeout(token.timer);
    active = null;
    observer?.disconnect();
    restoreControls();
    clearAddNotices();
    document.documentElement.removeAttribute('data-sn84-cart-busy');
    status('', token.feedback?.error || '');
    if (token.feedback?.retry) retryLink();
  };
  const request = async (input, options = {}, token = null) => {
    const url = new URL(input, location.href);
    if (url.origin !== location.origin) throw new Error('Cart origin mismatch');
    const controller = new AbortController();
    const signals = [...new Set([options.signal, token?.controller?.signal].filter(Boolean))];
    const abort = () => controller.abort();
    signals.forEach(signal => {
      if (signal.aborted) controller.abort();
      else signal.addEventListener('abort', abort, { once: true });
    });
    const timer = setTimeout(abort, 12000);
    try {
      if (token && String(options.method).toUpperCase() === 'POST') token.posted = true;
      const response = await fetch(url.href, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok && !data?.errors && !data?.status) throw new Error('Cart request failed');
      if (controller.signal.aborted) throw new DOMException('Aborted', 'AbortError');
      return data;
    } finally {
      clearTimeout(timer);
      signals.forEach(signal => signal.removeEventListener('abort', abort));
    }
  };
  const descriptors = () => {
    const result = [];
    ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble', 'cart-live-region-text'].forEach(id => {
      const element = document.getElementById(id);
      if (!element) return;
      const section = ['cart-icon-bubble', 'cart-live-region-text'].includes(id) ? id : element.dataset.id || element.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '') || id;
      result.push({ id, section, element });
    });
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') result.push({ id: 'cart-drawer', section: 'cart-drawer', element: drawer });
    return result;
  };
  const sectionIds = items => [...new Set(items.map(item => item.section))].slice(0, 5);
  const render = (sections, items = descriptors()) => {
    const parsed = items.map(item => {
      if (typeof sections?.[item.section] !== 'string') throw new Error('Cart section missing');
      const page = new DOMParser().parseFromString(sections[item.section], 'text/html');
      // These two sections contain fragments, not the ID of their live target.
      const fragment = ['cart-icon-bubble', 'cart-live-region-text'].includes(item.id);
      const fresh = item.id === 'cart-drawer' ? page.querySelector('cart-drawer') : fragment ? page.querySelector('.shopify-section') : page.getElementById(item.id);
      if (!fresh) throw new Error('Cart content missing');
      if (item.id === 'cart-drawer') {
        if (!fresh.querySelector('#CartDrawer-Overlay') || !fresh.querySelector('.drawer__inner')) throw new Error('Cart drawer missing');
        item.element.getSectionInnerHTML(sections[item.section], '#CartDrawer');
      }
      return { ...item, fresh };
    });
    parsed.forEach(item => {
      if (item.id === 'cart-drawer') {
        item.element.classList.toggle('is-empty', item.fresh.classList.contains('is-empty'));
        item.element.renderContents({ sections }, true);
      } else if (item.id === 'main-cart-items') {
        item.element.innerHTML = item.fresh.innerHTML;
        const freshCart = item.fresh.closest('cart-items');
        if (freshCart) item.element.closest('cart-items')?.classList.toggle('is-empty', freshCart.classList.contains('is-empty'));
      } else if (item.id === 'main-cart-footer') item.element.replaceWith(item.fresh);
      else item.element.innerHTML = item.fresh.innerHTML;
    });
    needsCartRefresh = false;
    sync();
  };
  const refresh = async token => {
    const items = descriptors();
    if (!items.length) return false;
    const url = new URL(window.routes?.cart_url || '/cart', location.href);
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    url.searchParams.set('sections', sectionIds(items).join(','));
    try {
      const sections = await request(url.href, {}, token);
      if (token?.controller.signal.aborted) throw new DOMException('Aborted', 'AbortError');
      render(sections, items);
      return true;
    } catch (error) {
      if (token?.posted) needsCartRefresh = true;
      throw error;
    }
  };
  const renderCart = async (cart, items, token) => {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Cart response missing');
    if (sectionIds(items).every(id => typeof cart.sections?.[id] === 'string')) render(cart.sections, items);
    else await refresh(token);
  };
  const restoreFocus = info => {
    if (!info || !document.querySelector('cart-drawer.active') && info.inDrawer) return;
    const scope = info.inDrawer ? document.querySelector('cart-drawer') : document.querySelector('cart-items');
    const line = scope?.querySelector(`#${info.inDrawer ? 'CartDrawer-Item-' : 'CartItem-'}${info.line}`);
    const target = line?.querySelector(info.name === 'updates[]' ? '.quantity__input' : `[name="${info.name === 'minus' ? 'minus' : 'plus'}"]`) || scope?.querySelector('.drawer__close, a, button');
    if (!target || target.disabled) return;
    target.focus({ preventScroll: true });
  };
  const update = async (owner, line, quantity, name, clear = false) => {
    const token = begin(owner, clear ? 'remove' : 'quantity');
    if (!token) return;
    const focus = { line, name: token.focusName || name, inDrawer: owner.matches('cart-drawer-items') };
    const items = descriptors();
    const input = document.getElementById(`${focus.inDrawer ? 'Drawer-quantity-' : 'Quantity-'}${line}`);
    let error = '';
    let posted = false;
    try {
      if (!clear && (String(quantity).trim() === '' || !Number.isInteger(Number(quantity)) || Number(quantity) < 0 || !Number.isInteger(Number(line)) || Number(line) < 1)) {
        if (input) input.value = input.getAttribute('value');
        error = failureText();
        return;
      }
      const body = { sections: sectionIds(items), sections_url: location.pathname };
      if (!clear) Object.assign(body, { line: Number(line), quantity: Number(quantity) });
      posted = true;
      const cart = await request(clear ? window.routes.cart_clear_url : window.routes.cart_change_url, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }, token);
      if (cart.errors || cart.status >= 400) {
        error = typeof cart.errors === 'string' ? cart.errors : cart.description || failureText();
        if (input) input.value = input.getAttribute('value');
      } else {
        await renderCart(cart, items, token);
        const actual = cart.items[Number(line) - 1]?.quantity;
        if (!clear && Number(quantity) > 0 && actual != null && actual !== Number(quantity)) error = window.cartStrings?.quantityError?.replace('[quantity]', actual) || failureText();
      }
    } catch {
      error = failureText();
      if (posted && !token.controller.signal.aborted) {
        try { await refresh(token); } catch { token.feedback = { error: failureText(), retry: true }; }
      }
    } finally {
      end(token);
      if (!token.controller.signal.aborted) {
        if (error) {
          if (!token.feedback) status('', error);
          const message = document.getElementById(focus.inDrawer ? 'CartDrawer-CartErrors' : 'cart-errors');
          if (message) message.textContent = error;
        }
        restoreFocus(focus);
        document.dispatchEvent(new CustomEvent('cartQuantityUpdated', { detail: { handle: 'sn84' } }));
      }
    }
  };
  const add = async (token, url, options) => {
    const items = descriptors();
    let refreshAttempted = false;
    try {
      if (options.body instanceof FormData) {
        options.body.set('sections', sectionIds(items).join(','));
        options.body.set('sections_url', location.pathname);
      } else {
        const payload = JSON.parse(options.body);
        options = { ...options, body: JSON.stringify({ ...payload, sections: sectionIds(items), sections_url: location.pathname }) };
      }
      token.lockSource = true;
      sync();
      token.posted = true;
      const cart = await request(url, options, token);
      if (!cart || typeof cart !== 'object' || Array.isArray(cart)) throw new Error('Cart add response missing');
      const rejected = cart.status >= 400 || Boolean(cart.errors);
      if (!rejected) {
        if (cart.id == null && !Array.isArray(cart.items)) throw new Error('Cart add confirmation missing');
        token.confirmed = true;
        if (sectionIds(items).every(id => typeof cart.sections?.[id] === 'string')) render(cart.sections, items);
        else {
          refreshAttempted = true;
          await refresh(token);
        }
      }
      return { ok: !rejected, json: async () => cart };
    } catch (error) {
      if (!token.controller.signal.aborted) {
        token.uncertain = token.posted && !token.confirmed;
        token.feedback = { error: token.uncertain ? cartStrings().addUncertain || failureText() : failureText(), retry: true };
        if (token.posted && !refreshAttempted) {
          try { await refresh(token); } catch { needsCartRefresh = true; }
        }
      }
      throw error;
    }
  };
  const reset = () => {
    if (active?.posted) needsCartRefresh = true;
    active?.controller.abort();
    end(active);
    checkoutPending = false;
    clearTimeout(checkoutTimer);
    observer?.disconnect();
    restoreControls();
    clearAddNotices();
    document.documentElement.removeAttribute('data-sn84-cart-busy');
    status('');
  };
  document.addEventListener('change', event => {
    if (!event.target.matches?.(quantitySelector)) return;
    const owner = event.target.closest('cart-items, cart-drawer-items');
    if (active || checkoutPending) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    const focusName = document.activeElement?.getAttribute('name');
    const token = begin(owner, 'quantity');
    if (!token) return;
    token.focusName = focusName;
    token.reserved = true;
    token.reserveTimer = setTimeout(() => end(token), 1500);
  }, true);
  document.addEventListener('click', event => {
    if (!active && !checkoutPending) return;
    if (event.target.closest?.(controls)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (guardAdd(form, event)) return;
    const checkout = form.matches?.('#cart, #CartDrawer-Form') && event.submitter?.name === 'checkout';
    const cartAction = form.matches?.('#cart, #CartDrawer-Form, form[data-sn74-discount], .sv15-suggest__form form');
    if (!cartAction) return;
    if (active || checkoutPending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    if (!checkout) return;
    if (needsCartRefresh) {
      event.preventDefault();
      event.stopImmediatePropagation();
      status('', failureText());
      retryLink();
      return;
    }
    checkoutPending = true;
    queueMicrotask(() => {
      if (event.defaultPrevented) { reset(); return; }
      document.documentElement.setAttribute('data-sn84-cart-busy', 'checkout');
      status('checkout');
    });
    checkoutTimer = setTimeout(reset, 15000);
  }, true);
  const viewport = window.visualViewport;
  let viewportFrame = null;
  const syncViewport = () => {
    viewportFrame = null;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (viewport && drawer.classList.contains('active') && matchMedia('(max-width: 749px)').matches) {
      drawer.style.setProperty('--sn84-viewport-height', `${Math.round(viewport.height)}px`);
      drawer.style.setProperty('--sn84-viewport-top', `${Math.round(viewport.offsetTop)}px`);
    } else {
      drawer.style.removeProperty('--sn84-viewport-height');
      drawer.style.removeProperty('--sn84-viewport-top');
    }
  };
  const scheduleViewport = () => {
    if (viewportFrame === null) viewportFrame = requestAnimationFrame(syncViewport);
  };
  const watchViewport = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(scheduleViewport).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    scheduleViewport();
  };
  viewport?.addEventListener('resize', scheduleViewport, { passive: true });
  viewport?.addEventListener('scroll', scheduleViewport, { passive: true });
  window.addEventListener('resize', scheduleViewport, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchViewport, { once: true });
  else watchViewport();
  window.addEventListener('pagehide', reset);
  window.addEventListener('pageshow', event => { if (event.persisted) reset(); scheduleViewport(); });
  window.Sn84CartState = { begin, end, request, refresh, render, descriptors, sectionIds, add, guardAdd, showAddError, updateQuantity: update, clear: owner => update(owner, null, 0, '', true), sync, busy: () => Boolean(active || checkoutPending) };
})();
